import { blueTheme } from '@/themes/blue-theme'
import { pinkTheme } from '@/themes/pink-theme'

// 主题配置映射
const themes = {
  blue: blueTheme,
  pink: pinkTheme
}

// 获取当前主题
export function getCurrentTheme() {
  // 在开发环境中，优先从localStorage获取（用于实时切换测试）
  if (process.env.NODE_ENV === 'development') {
    const devTheme = localStorage.getItem('dev-theme')
    if (devTheme && themes[devTheme]) {
      return themes[devTheme]
    }
  }
  
  // 生产环境：从环境变量获取（构建时确定）
  const envTheme = process.env.VUE_APP_THEME
  if (envTheme && themes[envTheme]) {
    return themes[envTheme]
  }
  
  // 默认返回蓝色主题
  return themes.blue
}

// 获取主题颜色
export function getThemeColors() {
  return getCurrentTheme().colors
}

// 获取主题名称
export function getThemeName() {
  return getCurrentTheme().name
}

// 检查是否为粉色主题
export function isPinkTheme() {
  return getThemeName() === 'pink'
}

// 检查是否为蓝色主题
export function isBlueTheme() {
  return getThemeName() === 'blue'
}

// 将十六进制颜色转换为RGB
function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

// 生成带透明度的颜色
function generateColorWithOpacity(hex, opacity) {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity / 100})`
}

// 动态生成CSS变量
export function generateThemeCSS() {
  const colors = getThemeColors()
  let css = ':root {\n'
  
  Object.entries(colors).forEach(([key, value]) => {
    css += `  --${key}: ${value};\n`
    
    // 为每个颜色生成透明度变体
    const opacityValues = [5, 10, 20, 50, 80, 90]
    opacityValues.forEach(opacity => {
      const colorWithOpacity = generateColorWithOpacity(value, opacity)
      css += `  --${key}-${opacity}: ${colorWithOpacity};\n`
    })
  })
  
  css += '}\n'
  return css
}

// 应用主题到页面
export function applyTheme() {
  const theme = getCurrentTheme()
  const css = generateThemeCSS()
  
  // 开发环境调试信息
  if (process.env.NODE_ENV === 'development') {
    console.log('应用主题:', theme.name)
    console.log('主题颜色:', theme.colors)
  }
  
  // 移除已存在的主题样式
  const existingStyle = document.getElementById('dynamic-theme')
  if (existingStyle) {
    existingStyle.remove()
  }
  
  // 创建新的样式元素
  const style = document.createElement('style')
  style.id = 'dynamic-theme'
  style.textContent = css
  document.head.appendChild(style)
}
